
import { ProjectsUI } from '@droid/project-v2-ui';
import { Box } from '@mui/material';
import { OpenA11yNodeButton } from '@src/components/a11y/open-a11y-node-button';
import { AndroidFloatWindowLink } from '@src/components/android-float/window/AndroidFloatWindowLink';
import { KillSelf } from '@src/components/app/kill-self/KillSelf';
import { DocMainPage } from '@src/components/browser/DocMainPage';
import { NotificationListenerPanel } from '@src/components/notification-listener/NotificationListenerPanel';
import { AutoTranslateToggle, toProxy, TranslationComponent } from '@fanfanlo';
import { MainPageAddButtons } from '@src/components/markets/main-page-add-buttons/MainPageAddButtons';


export function HomeGlobalDevContent() {
  return (
    <>
      <Box>
        {/* <AndroidSettingsInfo />
            <AddExternalMarketButton />
            <HomePagePermissions /> */}
        <NotificationListenerPanel />
        {/* <TestA11y /> */}
        <AndroidFloatWindowLink />
        <Box>
          <OpenA11yNodeButton />
        </Box>

        <DocMainPage />
        {/* <TextRecognitionControl /> */}
        {/* 这个代码的调用的外部script文件没找到 */}
        {/* <TestScript /> */}
        <Box>
          <KillSelf />
        </Box>
        {/* <MarketsDevSettingsLineOpenLinkButton /> */}
        {/* <MainPageAddButtons /> */}
        <ProjectsUI />
        {/* <AndroidPermissionsSelector permissions={[]} />
        <div>
          <ExampleButton />
          <TestAndroidePermissionsButton />
        </div> */}
        <div>
          {/* 添加开关按钮 */}
          <AutoTranslateToggle variant="checkbox" />

          {/* 需要翻译的内容 */}
          {/* <TranslationComponent>Hello, this is a test.</TranslationComponent>

          <TranslationComponent isHtml={true}>
            <h1>Title</h1>
            <p>Content</p>
          </TranslationComponent> */}
        </div>
      </Box>
    </>
  );
}
